/**
 * There are many dependencies that are shared across Angular and angular.js sections of staff.
 * To avoid duplication is preferred to have them in the Angular side and re-export them to angular
 */
import * as DMSServices from '@onviobr/toolbox-document-services/dist/esm5';
import * as DMSModels from '@onviobr/toolbox-document-services/dist/esm5/models';
import * as moment from 'moment';
import * as d3 from 'd3';
import * as _ from 'underscore';

(window as any).bm = (window as any).bm ?? {};
(window as any).bm.services = (window as any).bm.services ?? {};
(window as any).bm.services.documents = DMSServices;
(window as any).bm.services.documents.models = DMSModels;
(window as any).moment = moment;
(window as any).d3 = d3;
(window as any)._ = _;
